import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";

const SUCCESE = async (data: any) => {
  toast.success(data, {
    position: toast.POSITION.TOP_LEFT,
  });
};
const FAILED = async (data: any) => {
  console.log(data);
  toast.error(data.message, {
    position: toast.POSITION.TOP_LEFT,
  });
};

export const RequestClarification = createSlice({
  name: "RequestClarification",
  initialState: {
    data: [],
    isLoading: false,
    api_completed: false,
    isCompleted: false,
    isSuccess: false,
  },
  reducers: {
    request_clarification: (state, action?: any) => {
      state.isLoading = true;
    },
    success_request_clarification: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      // SUCCESE(action.payload.message);
    },
    failure_request_clarification: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.api_completed = true;
      // FAILED(action.payload);
    },
    request_clarification_is_success: (state, action) => {
      state.isSuccess = false;
    },
    request_clarification_complete_api: (state, action?) => {
      state.api_completed = false;
    },
  },
});
export default RequestClarification.reducer;
export const {
  request_clarification,
  request_clarification_is_success,
  success_request_clarification,
  request_clarification_complete_api,
  failure_request_clarification,
} = RequestClarification.actions;
